<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Brands</h1>
  <div class="d-flex gap-2">
    <a [routerLink]="['add']" *isGranted="['ROLE_API_PRODUCT_WRITE']" class="btn btn-primary fw-bold"><i
    class="bi bi-plus-lg me-2"></i>Add Brand
  </a>
</div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">

    <!--    <div class="d-flex justify-content-end align-items-center mb-3">-->
    <!--      <button class="btn btn-primary fw-bold" onclick="location.href='createnewuser.html'"><i-->
  <!--        class="bi bi-person-plus"></i> Create New User-->
<!--      </button>-->
<!--    </div>-->
<div class="table-responsive">
  <table class="table table-hover table-striped align-middle">
    <thead>
      <tr [tableSorter]="tableSorter" (tableSorterChange)="refresh()">
        <th>Logo</th>
        <th tableSorterHeader="id">ID</th>
        <th tableSorterHeader="name">Name</th>
        <th tableSorterHeader="advertiser">Advertiser</th>
        <th tableSorterHeader="type">Type</th>
        <th tableSorterHeader="domain">Domain</th>
        <th>Languages</th>
        <th tableSorterHeader="identifier">API Identifier</th>
        <th tableSorterHeader="enabled">Status</th>
        <th class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      @for (product of products; track product) {
        <tr>
          <td>
            <div class="logo">
              @if (product.logo) {
                <img [ngSrc]="imageService.getImageUrl(product.logo, 128, 128)" alt="Logo" fill/>
              }
            </div>
          </td>
          <td>{{ product.id }}</td>
          <td>{{ product.name }}</td>
          <td>{{ product.advertiser }}</td>
          <td>{{ product.type }}</td>
          <td>{{ product.domain }}</td>
          <td>
            @for (lang of product.languages; track lang) {
              <span>
                <img [ngSrc]="langService.getFlag(lang ?? '')" [alt]="lang" width="24"
                  height="24" class="me-1">
              </span>
            }
          </td>
          <td>{{ product.identifier }}</td>
          <td>
            @if (product.enabled) {
              <span class="badge bg-success">Enabled</span>
            }
            @if (!product.enabled) {
              <span class="badge bg-danger">Disabled</span>
            }
          </td>
          <td class="text-center">
            <a class="btn btn-outline-primary btn-sm" [routerLink]="[product.id]"><i class="bi bi-pencil me-1"></i>Edit</a>
            <button *isGranted="['ROLE_API_PRODUCT_WRITE']" class="btn btn-outline-danger btn-sm ms-1" appConfirm
              (click)="delete(product)"><i class="bi bi-trash"></i></button>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <app-paginator (pageChange)="refresh()" [paginator]="paginator"></app-paginator>
  </div>
</div>
</div>
